

















































import { Component, Vue, Prop, PropSync, Watch } from "vue-property-decorator";
import PlanPeriodSelect from "./PlanPeriodSelect.vue";
import ETFAsset from "./ETFAsset.vue";
import { ETF, Frequency } from "@foxone/api/src/models/hfox";
import { USDT_ASSET } from "hfox/constants";

export enum FormMode {
  EDIT = "edit",
  CREATE = "create"
}

export type PlanFormData = {
  name: string;
  etf: string;
  funds: string;
  period: {
    frequency: null | Frequency;
    day: null | number;
    hour: null | number;
  };
};

@Component({
  components: {
    PlanPeriodSelect,
    "etf-asset": ETFAsset
  }
})
class PlanForm extends Vue {
  @PropSync("plan") bindPlan!: PlanFormData;

  @Prop() mode!: FormMode;

  @Prop() etfs!: ETF[];

  @Prop() loading!: boolean;

  FormMode = FormMode;

  sheet = false;

  get bindAmount() {
    return this.bindPlan.funds;
  }

  set bindAmount(v) {
    const value = this.$common.utils.number.toPrecision(v, 8);
    const amountInput: any = this.$refs.amountInput;
    this.bindPlan.funds = value + "";
    amountInput.lazyValue = value;
  }

  get asset() {
    return this.meta.etfItems.find(item => item.symbol === this.bindPlan.etf);
  }

  set asset(val: any) {
    this.bindPlan.etf = val.symbol;
  }

  @Watch("bindPlan.etf")
  handleEtfChange(value) {
    if (!this.bindPlan.name && value) {
      this.bindPlan.name = value;
    }
  }

  get meta() {
    const etf = this.etfs.find(e => e.name === this.bindPlan.etf);
    const limit = etf && {
      min: Number(etf.min_funds),
      max: Number(etf.max_funds)
    };
    const fundsHint = limit
      ? this.$t("common.amount.limit", { min: limit.min, max: limit.max })
      : "";

    return {
      etf,
      limit,
      fundsHint,
      payAsset: USDT_ASSET.symbol,
      etfItems: this.etfs.map(e => ({ symbol: e.name, id: e.asset_id, ...e }))
    };
  }

  get rules() {
    const limit = this.meta.limit;
    return {
      etf: [v => !!v || this.$t("hfox.etf.required")],
      funds: [
        v => !!v || this.$t("hfox.plan.funds.required"),
        v => {
          if (!limit) {
            return true;
          }
          if (+v > limit.max) {
            return this.$t("common.amount.limit", {
              min: limit.min,
              max: limit.max
            });
          }
          if (+v < limit.min) {
            return this.$t("common.amount.limit", {
              min: limit.min,
              max: limit.max
            });
          }
          return true;
        }
      ]
    };
  }

  mounted() {
    if (this.mode === FormMode.CREATE && this.etfs.length > 0) {
      this.sheet = true;
    }
  }

  handleSelectAsset(val) {
    this.asset = val;
    this.sheet = false;
  }

  handleSave() {
    const form: any = this.$refs.form;
    const valid = form.validate();
    if (valid) {
      this.$emit("save");
    }
  }
}
export default PlanForm;
